module.exports = __webpack_public_path__ + "static/media/it.48651b91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/it.svg
// module id = 155
// module chunks = 0